export default __webpack_public_path__ + "static/media/star.e22e1422.svg";